//=================================================================================================

import { VisionApplication } from '../../application';
import { Measurement } from '../../components/measurement';
import { AssetDTO } from '../../service/asset';
import { PreventativeMaintenanceTab } from './pm';
import { PMType, PMTypeDTO } from './pmservice';

export class PMSelectWindow {
    private pmTypes: Map<string, PMTypeDTO>;
    private asset: AssetDTO | undefined;
    private odoOffsetKm = 0.0;
    private hoursOffset = 0.0;
    private parent: PreventativeMaintenanceTab;
    private formObj!: dhtmlXForm;
    private assetId: string;
    private selectedPMType: PMTypeDTO | undefined;

    constructor(win: dhtmlXWindows, parent: PreventativeMaintenanceTab, assetid: string) {
        this.pmTypes = parent.pmtypes;
        this.parent = parent;
        this.assetId = assetid;

        const form = [
            { name: 'pm', type: 'select', label: 'PM', value: '', offsetLeft: '25', required: true, inputWidth: 100, options: [{ text: 'None', value: 'NONE' }] },

            // TODO add current and last fields
            { name: 'last_done_hours', type: 'input', label: 'Last Done Hours', value: '', labelAlign: 'left', offsetLeft: '25', hidden: true, tooltip: 'Blank for current value.' },
            { name: 'current_hours', type: 'input', label: 'Current Hours', value: '', labelAlign: 'left', offsetLeft: '25', hidden: true, tooltip: 'Blank for current value.' },
            { name: 'due_at_hours', type: 'input', label: 'Due at Hours', value: '', labelAlign: 'left', offsetLeft: '25', hidden: true, tooltip: 'Blank for current value.' },
            { name: 'last_done_odometer', type: 'input', label: 'Last Done Odometer', value: '', labelAlign: 'left', offsetLeft: '25', hidden: true, tooltip: '.' },
            { name: 'current_odometer', type: 'input', label: 'Current Odometer', value: '', labelAlign: 'left', offsetLeft: '25', hidden: true, tooltip: '.' },
            { name: 'due_at_odometer', type: 'input', label: 'Due at Odometer', value: '', labelAlign: 'left', offsetLeft: '25', hidden: true, tooltip: 'Blank for current value.' },
            { name: 'due_at_days', type: 'calendar', label: 'Due at (day):', value: '', labelAlign: 'left', offsetLeft: '25', hidden: true, tooltip: 'Blank for current value.' },
            { name: 'due_at_date', type: 'calendar', label: 'Due at (date):', value: '', labelAlign: 'left', offsetLeft: '25', hidden: true, tooltip: 'Blank for current value.' },
            { type: 'button', name: 'select_pm', value: 'Select' },
        ];

        const pmtypes = parent.service.getTypes(false);
        this.asset = VisionApplication.getInstance().assetService.assetList.get(assetid);

        VisionApplication.getInstance()
            .assetService.getAssetMap()
            .then((assetMap) => assetMap.get(assetid))
            .then((asset) => {
                this.asset = asset;

                if (this.asset != undefined) {
                    this.odoOffsetKm = this.asset.odoOffset;
                    this.hoursOffset = this.asset.hoursOffset;
                }

                pmtypes.then((data) => {
                    data.forEach((item) => {
                        form[0].options?.push({ text: item.name, value: item.id });
                    });

                    const window = win.createWindow('pm_type_select', 30, 30, 400, 600);
                    window.setText('Select PM');
                    this.formObj = window.attachForm(form);

                    this.formObj.attachEvent('onButtonClick', (_name) => {
                        this.submit();
                    });

                    this.formObj.attachEvent('onChange', (name: string, _value: string | number, _state: boolean) => {
                        if (name == 'pm') {
                            this.setupDueAtFields();
                        }
                        if (name == 'last_done_odometer') {
                            this.recalculateDueOdometer();
                        }
                    });
                });
            });
    }

    private recalculateDueOdometer() {
        let lastDoneOdometerKm = Measurement.miles2km(parseFloat(this.formObj.getItemValue('last_done_odometer')));
        lastDoneOdometerKm -= this.odoOffsetKm;
        if (this.selectedPMType) {
            const dueOdometerKm = lastDoneOdometerKm + this.selectedPMType.odometerIntervalKm;
            const dueOdometerMiles = Measurement.km2miles(dueOdometerKm + this.odoOffsetKm);
            this.formObj.setItemValue('due_at_odometer', dueOdometerMiles.toString());
        }
    }

    private submit() {
        let hours = this.formObj.getItemValue('due_at_hours');
        let odoMiles = this.formObj.getItemValue('due_at_odometer');
        let odoKm = 0.0;
        const days = this.formObj.getItemValue('due_at_days')?.getTime();
        const date = this.formObj.getItemValue('due_at_date')?.getTime();

        if (hours == '') {
            hours = undefined;
        } else {
            hours = parseFloat(hours);
        }

        if (odoMiles == '') {
            odoMiles = undefined;
        } else {
            odoKm = Measurement.miles2km(odoMiles);
        }

        const currentOdometerKm = Measurement.miles2km(parseFloat(this.formObj.getItemValue('current_odometer')));
        const currentHours = parseFloat(this.formObj.getItemValue('current_hours'));

        this.parent.createPM(this.formObj.getItemValue('pm'), this.assetId, odoKm, hours, days, date, currentOdometerKm, currentHours);
    }

    /** Setup the form to ask user when next due  */
    private setupDueAtFields() {
        this.formObj.hideItem('due_at_hours');
        this.formObj.hideItem('last_done_hours');
        this.formObj.hideItem('current_hours');

        this.formObj.hideItem('due_at_odometer');
        this.formObj.hideItem('last_done_odometer');
        this.formObj.hideItem('current_odometer');

        this.formObj.hideItem('due_at_days');
        this.formObj.hideItem('due_at_date');

        const selectedPM = this.formObj.getItemValue('pm');
        //const telemetry = VisionApplication.getInstance().latestService.assetCache.get(this.assetId);

        VisionApplication.getInstance()
            .latestService.getLatestForAsset(this.assetId)
            .then((telemetry) => {
                if (telemetry) {
                    const currentOdometerMiles = Measurement.km2miles(telemetry.odometer + this.odoOffsetKm);
                    this.formObj.setItemValue('current_odometer', currentOdometerMiles.toString());
                    const currentHours = telemetry.hours + this.hoursOffset;
                    this.formObj.setItemValue('current_hours', currentHours.toString());
                }

                const selectedType = this.parent.pmtypes.get(selectedPM);
                this.selectedPMType = selectedType;

                if (selectedType) {
                    // ********************
                    // Process the Odometer
                    if (selectedType.odometerIntervalKm > 0) {
                        this.formObj.showItem('last_done_odometer');
                        this.formObj.showItem('current_odometer');
                        this.formObj.showItem('due_at_odometer');

                        if (telemetry) {
                            const currentOdometerMiles = Measurement.km2miles(telemetry.odometer + this.odoOffsetKm);
                            const odoMiles = Measurement.km2miles(telemetry.odometer + this.odoOffsetKm + selectedType.odometerIntervalKm);
                            this.formObj.setItemValue('last_done_odometer', currentOdometerMiles.toString());
                            this.formObj.setItemValue('current_odometer', currentOdometerMiles.toString());
                            this.formObj.setItemValue('due_at_odometer', odoMiles.toString());
                        } else {
                            const odoMiles = Measurement.km2miles(selectedType.odometerIntervalKm + this.odoOffsetKm);
                            this.formObj.setItemValue('due_at_odometer', odoMiles.toString());
                        }
                    }

                    // ********************
                    // Process the Hours
                    if (selectedType.hoursInterval > 0) {
                        this.formObj.showItem('due_at_hours');
                        this.formObj.showItem('last_done_hours');
                        this.formObj.showItem('current_hours');

                        if (telemetry) {
                            const currentHours = telemetry.hours + this.hoursOffset;
                            const dueAtHours = telemetry.hours + this.hoursOffset + selectedType.hoursInterval;

                            this.formObj.setItemValue('due_at_hours', dueAtHours.toString());
                            this.formObj.setItemValue('last_done_hours', currentHours.toString());
                            this.formObj.setItemValue('current_hours', currentHours.toString());
                        } else {
                            this.formObj.setItemValue('due_at_hours', selectedType.hoursInterval.toString());
                        }
                    }

                    if (selectedType.daysInterval > 0) {
                        const dueDays = new Date().getTime() + selectedType.daysInterval * 24 * 60 * 60 * 1000;
                        this.formObj.showItem('due_at_days');

                        this.formObj.setItemValue('due_at_days', new Date(dueDays));
                    }
                    if (selectedType.dateInterval > 0) {
                        const dueDate = new Date(new Date(new Date().getFullYear(), selectedType.dateMonth, selectedType.dateDay).setHours(0, 0, 0, 0));

                        this.formObj.showItem('due_at_date');
                        this.formObj.setItemValue('due_at_date', new Date(dueDate));
                    }
                }
            });
    }
}
